/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { checkQuarterValidation } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  REBATE_PROGRAM_REQUIRED_REQ,
  CALCULATED_QUATER_REQUIRED,
  INVALID_QTR_ERR,
  PRICE_TYPE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import _ from 'lodash';

export const PRODUCT_CODE_SIZE = 'Size of Product Code should always be 4.';
export const PACKAGE_SIZE_ERROR = 'Size of Package Size should always be 2.';
export const TARGET_QUARTER_ERROR = 'Target Quarter is required.';
export const VALID_QUARTER_ERROR =
  'Please enter a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 4Q1997.';
export const FUTURE_QUARTER_ERROR =
  'Target Quarter cannot be a future quarter.';
export const TABLE_ROW_ERROR = 'Add at least one row to save the details.';
export const planTypeRadioData = [
  // { name: 'Medicaid', value: 'FD' },
  { name: 'State', value: 'ST' },
  { name: 'Commercial', value: 'COMM' },
  { name: 'Supplemental', value: 'SUPP' },
];
export const dataContentRadioData = [
  { name: 'Single Price', value: 'Single' },
  { name: 'Multiple Price', value: 'Multiple' },
];
export const dataSourceRadioData = [
  { name: 'Manually enter Price Data', value: 'Manual' },
  { name: 'View Existing Price Data', value: 'View' },
  { name: 'Upload Price Data from File', value: 'Upload' },
];

export const multiPriceSelectionRadioData = [
  { name: 'Price', value: 'Price' },
  { name: 'URA', value: 'URA' },
];

export const drugCategoryDropdouwnData = { 
  I: 'I | Inovator',
  N: 'N | Non Innovator',
  S: 'S | Single Source',
};

export const validateHeaderFields = (searchFilter, name, value) => {
  const error = [];
  const errorObj = {};
  if (searchFilter && searchFilter.planType) {
    if (
      (name === 'rpc' && value == '-1') ||
      (name !== 'rpc' && searchFilter?.rpc === '')
    ) {
      errorObj.rpc = REBATE_PROGRAM_REQUIRED_REQ;
      error.push(REBATE_PROGRAM_REQUIRED_REQ);
    }

    if (
      (name === 'priceType' && value == '-1') ||
      (name !== 'priceType' && searchFilter?.priceType === '')
    ) {
      errorObj.priceType = PRICE_TYPE_REQUIRED;
      error.push(PRICE_TYPE_REQUIRED);
    }

    if (name === 'calcQtr' || name !== 'calcQtr') {
      if (name !== 'calcQtr') {
        value = searchFilter?.calcQtr;
      }
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (!checkQuarterValidation(value)) {
          errorObj.calcQtr = INVALID_QTR_ERR;
          error.push(INVALID_QTR_ERR);
        }
      } else if (value === '') {
        errorObj.calcQtr = CALCULATED_QUATER_REQUIRED;
        error.push(CALCULATED_QUATER_REQUIRED);
      }
    }
    return { error, errorObj };
  }
};
